import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/projects/components/ProjectsGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/projects/components/ProjectsHero.tsx");
